import React, { useCallback } from 'react'
import styled from 'styled-components'
import { ApplicationDataFull } from '../../../types/ApplicationData'
import Overlay, { OverlaySection } from '../../components/Overlay'
import ApplicationPreview from '../../components/preview/ApplicationPreview'
import { expertLoadInspirationConfigurationAction } from '../../store/actions/uiActions'
import { useDispatch, useSelector } from '../../store/hooks'
import { useTranslation } from '../../store/hooks/dataHooks'

const PresetTiles = styled.div`
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-column-gap: 20px;
`

const ApplicationTile = styled<React.FC<{ className?: string; application: ApplicationDataFull }>>(function ({
  className,
  application
}) {
  const dispatch = useDispatch()
  const onClick = useCallback(() => {
    dispatch(expertLoadInspirationConfigurationAction(application.id, true))
  }, [dispatch, application.id])

  return (
    <button className={'teaser ' + className} onClick={onClick}>
      <div className="teaser__thumbnail">
        <div>
          <ApplicationPreview application={application} />
        </div>
      </div>
      <div className="teaser__content">
        <h6>{application.title}</h6>
      </div>
    </button>
  )
})`
  text-align: left;

  .teaser__thumbnail {
    position: relative;
    background-color: #b2b2b2;

    &::after {
      content: '';
      display: block;
      padding-bottom: 56.25%;
    }

    > div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
`

const ApplicationOverlay: React.FC = function ApplicationOverlay() {
  const visible = useSelector((state) => state.ui.expert.showApplications)
  const applications = useSelector((state) => state.data.applications)

  const t = useTranslation()

  return (
    <Overlay visible={visible} shaded>
      <OverlaySection $title={t('ui.presets')} $bigTitle $fluid>
        <PresetTiles>
          {applications.map((application) => (
            <ApplicationTile key={application.id} application={application} />
          ))}
        </PresetTiles>
      </OverlaySection>
    </Overlay>
  )
}

export default ApplicationOverlay
